import React from 'react';
import { History } from 'history';
import { Button, Input } from '../../components';
import Model from './user-model';  //editable..
import BaseView from '../base/base-view.component';

interface IProps { 
    history: History;
    code: string;
}

interface IState {
    datarow: Model;
    errors: any;
}

export default class UserAuthConfirmationEmail extends  React.Component<IProps, IState> {
    constructor(props:IProps) {
        super(props);  
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
        }
        this.onChange = this.onChange.bind(this);
    }

    private onLoad = (data: any) => {
        this.setState({datarow:  data});
    }

    private onError = (data: any) => {
        this.setState({errors: data});
    }
    
    private onChange(fieldName: string, value?: string) { 
        const nextState = {
            ...this.state, datarow: {
                ...this.state.datarow, [fieldName]: value,
            }
        }
        this.setState(nextState);
    }
    
    render() {
        return (
            <BaseView history={this.props.history} caption={Model.caption || 'Confirmation Email'} 
                endPoint={Model.endPointAuth+ '/email-confirmation'} endPointFilter='?confirmation=' model={Model} onLoad={this.onLoad} onError={this.onError} disableBackButton>              
                 <Input name='confirmation' label='Confirmation Code' value={this.props.code} error={this.state.errors?.confirmation} readOnly/>
                 <Button label='Back' type='contained' onClick={() =>this.props.history.push('/')}/>
            </BaseView>
        )
    }     
     
}